import { useQueryClient } from '@tanstack/react-query';

import { queryKeys } from 'api/config';
import { MenuItem } from 'shared';
import { Icon, iconNames } from 'shared_DEPRECATED/components/Icon';

import { useSessionDeletion } from 'features/sessions/hooks';

type SessionsTableMoreOptionsDeleteMenuItemProps = {
  sessionId: string;
};

export const SessionsTableMoreOptionsDeleteMenuItem = ({
  sessionId,
}: SessionsTableMoreOptionsDeleteMenuItemProps) => {
  const queryClient = useQueryClient();
  const { openConfirmationModal } = useSessionDeletion(sessionId, () => {
    queryClient.invalidateQueries([queryKeys.participants]);
  });

  return (
    <MenuItem
      onClick={(evt: React.MouseEvent<HTMLButtonElement>) => {
        evt.stopPropagation();
        openConfirmationModal();
      }}
    >
      <Icon
        name={iconNames.bin}
        width="16px"
        height="18px"
        fill="var(--fgPrimary)"
      />{' '}
      Delete
    </MenuItem>
  );
};
